import React, { useMemo } from "react";
import { useAppContext } from "../../helpers/account-context";

const RegionsOptions = (props) => {
  const { filters, onApplyFilters } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP
  const { initedData: {enabledRegions}, getLocale, regions } = useAppContext()

  const enabledCountries = enabledRegions.indexOf('all') >= 0 || enabledRegions.indexOf('countries') >= 0;
  const enabledStates = enabledRegions.indexOf('all') >= 0 || enabledRegions.indexOf('provinces') >= 0;
  const enabledCities = enabledRegions.indexOf('all') >= 0 || enabledRegions.indexOf('cities') >= 0;

  const countries = useMemo(
    () => [...new Set(regions.map(item => item.country))],
    [regions]
  );
  const provRegions = useMemo(
    () => regions.filter((item) => (!filters.country || (filters.country.toLowerCase() === item.country.toLowerCase())))
    , [regions, filters.country]);
  const provinces = useMemo(
    () => [...new Set(provRegions.map(item => item.state))]
    , [provRegions]);
  const cityRegions = useMemo(
    () => regions.filter((item) => (!filters.country || !filters.province || (filters.country.toLowerCase() === item.country.toLowerCase() && filters.province.toLowerCase() === item.state.toLowerCase())))
    , [regions, filters.country, filters.province]);
  const cities = useMemo(
    () => [...new Set(cityRegions.map(item => item.city))]
    , [cityRegions]);

  const handleChangeCountry = (e) => {
    onApplyFilters({
      ...filters,
      country: e.target.value,
      province: null,
    })
  }
  
  const handleChangeProvince = (e) => {
    onApplyFilters({
      ...filters,
      province: e.target.value,
      city: null
    })
  }

  const handleChangeCity = (e) => {
    onApplyFilters({
      ...filters,
      city: e.target.value,
    })
  }

  return  (
    <div className="cbmap-region-options">
      {
        enabledCountries && <select className="region-country" value={`${filters.country || ''}`} onChange={handleChangeCountry}>
        <option value="">{getLocale('select_country')}</option>
        {countries.map((country, idx) => (
          <option key={`cty-${idx}`} value={country}>{country}</option>
        ))}
      </select>
      }
      
      {
        enabledStates && <select className="region-province" value={`${filters.province || ''}`} onChange={handleChangeProvince}>
        <option value="">{getLocale('select_province')}</option>
        {provinces.map((province, idx) => (
          <option key={`prov-${idx}`} value={province}>{province}</option>
        ))}
      </select>
      }
      
      {
        enabledCities &&  <select className="region-city"  value={`${filters.city || ''}`} onChange={handleChangeCity}>
        <option value="">{getLocale('select_city')}</option>
        {cities.map((city, idx) => (
          <option key={`city-${idx}`} value={city}>{city}</option>
        ))}
      </select>
      
      }
     
    </div>
  )
};

export default RegionsOptions;
